export type RoutePreviewPoint = {
  lat: number
  lng: number
}

export type RoutePreviewStop = {
  place?: null | {
    lat?: null | string
    lng?: null | string
  }
  type?: 'collection' | 'delivery'
}

export const getRoutePreviewPoint = (stop: RoutePreviewStop) => {
  const lat = stop.place?.lat
  const lng = stop.place?.lng

  if (lat == null || lng == null) {
    return null
  }

  const parsedLat = Number(lat)
  const parsedLng = Number(lng)

  if (Number.isNaN(parsedLat) || Number.isNaN(parsedLng)) {
    return null
  }

  return {
    lat: parsedLat,
    lng: parsedLng,
  } satisfies RoutePreviewPoint
}
